/** Minimal promise-concurrency limiter: at most `max` thunks run at once,
 *  the rest queue FIFO. A thunk's work (and any deadline inside it) starts
 *  only when its slot frees up. */
export function pLimit(max: number) {
  let active = 0;
  const queue: Array<() => void> = [];
  const release = () => {
    active--;
    queue.shift()?.();
  };
  return function limited<T>(fn: () => Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const run = () => {
        active++;
        fn().then(
          (v) => { release(); resolve(v); },
          (e) => { release(); reject(e); }
        );
      };
      if (active < max) run();
      else queue.push(run);
    });
  };
}
